module.exports = __webpack_public_path__ + "static/img/logo.d894339.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gameIntro/logo.png
// module id = E4Ep
// module chunks = 1